<template>
  <div>
    <v-sheet color="#A8CF45" width="100%" height="4px"></v-sheet>

    <v-sheet class="px-3 py-6 py-md-8" color="#DFDFDF">
      <div class="d-flex flex-column align-center justify-center">
        <div class="d-flex text-h6 text-sm-h5 text-center font-weight-black">
          {{ phone }}
        </div>

        <div
          class="d-flex text-h6 text-sm-h5 text-center font-weight-medium mt-1"
        >
          {{ address }}
        </div>
        <div class="text-center mt-5">
          CNPJ 19.027.760/0001-10 <br />
          CONTROL P SOLUÇÕES EM IMPRESSÕES LTDA
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
const _data = {
  phone: "(66)3532-4172 WhatsApp",
  address: "Rua Projetada 1, Residencial Canadá, Sinop/MT",
};

export default {
  data: () => ({
    ..._data,
  }),
};
</script>
